<template>
  <div class="d-flex">
    <v-card
      dark
      class="ma-2 text-left label background--text"
      style="
        position: relative;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 0px 8px 8px 8px;
        max-width: 85%;
      "
      color="primary"
    >
      <div class="pa-2 ma-1" style="background: #e9e9e9; border-radius: 8px">
        <strong class="primary--text mr-1" style="font-weight: 700">
          Usuário:
        </strong>
        <span class="black--text">{{
          message.sender ? message.sender.name : 'Usuário indefinido'
        }}</span>
      </div>

      <div class="pa-2">
        <div v-if="message.type == 2" class="ma-2 mr-4">
          <v-dialog max-width="60%" transition="dialog-bottom-transition">
            <template #activator="{ on, attrs }">
              <img
                style="max-width: 100%; border-radius: 10px"
                :src="message.picPath"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <v-img :src="message.picPath" style="border-radius: 10px"></v-img>
          </v-dialog>
        </div>

        <div
          class="text-message"
          :class="message.type === 1 ? 'text-center' : ''"
          :style="
            isSingleEmoji
              ? 'font-size: 40px; padding-top: 10px; padding-bottom: 5px;'
              : ''
          "
          v-html="message.content"
        ></div>

        <strong class="text-time t6" style="font-size: 10px">
          <!-- <v-icon color="white" small class="mb-1">
            {{ message.dateRead ? 'mdi-check-all' : 'mdi-check' }}
          </v-icon> -->
          {{ getChatHours(message.createdAt) }}
        </strong>
      </div>
    </v-card>
    <v-spacer></v-spacer>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'LeftMessageComponent',

  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isSingleEmoji() {
      const regex =
        /^(?:[\u2700-\u27BF]|(?:\uD83C[\uDDE6-\uDDFF]){2}|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u0023-\u0039]\uFE0F?\u20E3|\u3299|\u3297|\u303D|\u3030|\u24C2|\uD83C[\uDD70-\uDD71]|\uD83C[\uDD7E-\uDD7F]|\uD83C\uDD8E|\uD83C[\uDD91-\uDD9A]|\uD83C[\uDDE6-\uDDFF]|[\uD83C[\uDE01\uDDFF]|\uD83C[\uDE01-\uDE02]|\uD83C\uDE1A|\uD83C\uDE2F|[\uD83C[\uDE32\uDE02]|\uD83C\uDE1A|\uD83C\uDE2F|\uD83C[\uDE32-\uDE3A]|[\uD83C[\uDE50\uDE3A]|\uD83C[\uDE50-\uDE51]|\u203C|\u2049|[\u25AA-\u25AB]|\u25B6|\u25C0|[\u25FB-\u25FE]|\u00A9|\u00AE|\u2122|\u2139|\uD83C\uDC04|[\u2600-\u26FF]|\u2B05|\u2B06|\u2B07|\u2B1B|\u2B1C|\u2B50|\u2B55|\u231A|\u231B|\u2328|\u23CF|[\u23E9-\u23F3]|[\u23F8-\u23FA]|\uD83C\uDCCF|\u2934|\u2935|[\u2190-\u21FF])$/g

      return regex.test(this.message.content)
    },
  },

  methods: {
    getChatHours(date) {
      if (date) {
        if (
          moment(date).format('HH:mm') === moment(new Date()).format('HH:mm')
        ) {
          return 'Agora'
        }

        if (
          moment(date).format('DD/MM/yyyy') !==
          moment(new Date()).format('DD/MM/yyyy')
        ) {
          return moment(date)
            .locale(this.$i18n.locale)
            .format('DD/MM/yyyy HH:mm')
        }

        return moment(date).locale(this.$i18n.locale).format('HH:mm')
      }

      return date
    },
  },
}
</script>

<style scoped></style>
